'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Transhand = require('./Transhand');

var _Transhand2 = _interopRequireDefault(_Transhand);

var _CSSCoordinator = require('./CSSCoordinator');

var _CSSCoordinator2 = _interopRequireDefault(_CSSCoordinator);

var _lodashLangIsElement = require('lodash/lang/isElement');

var _lodashLangIsElement2 = _interopRequireDefault(_lodashLangIsElement);

var _lodashObjectAssign = require('lodash/object/assign');

var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);

var CSSTranshand = (function (_React$Component) {
  _inherits(CSSTranshand, _React$Component);

  _createClass(CSSTranshand, null, [{
    key: 'propTypes',
    value: (function () {
      var pt = (0, _lodashObjectAssign2['default'])(_Transhand2['default'].propTypes, {
        deTarget: function deTarget(props, name) {
          if (!(0, _lodashLangIsElement2['default'])(props[name])) {
            return new Error('deTarget should be a DOM Element!');
          }
        },
        autoUpdateCoordinatorFrequency: _react.PropTypes.number
      });

      delete pt.rect;
      delete pt.coordinator;

      return pt;
    })(),
    enumerable: true
  }]);

  function CSSTranshand(props) {
    var _this = this;

    _classCallCheck(this, CSSTranshand);

    _get(Object.getPrototypeOf(CSSTranshand.prototype), 'constructor', this).call(this, props);

    this.coordinator = new _CSSCoordinator2['default']();

    this.state = {
      rect: { x: 0, y: 0, w: 0, h: 0 }
    };
    //TODO do this somehow better!
    setTimeout(function () {
      return _this.takeNextDeTarget(props.deTarget);
    });
  }

  _createClass(CSSTranshand, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.takeNextDeTarget(nextProps.deTarget);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.startAutoUpdateCoordinator();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopAutoUpdateCoordinator();
      this.coordinator.destroy();
    }
  }, {
    key: 'takeNextDeTarget',
    value: function takeNextDeTarget(nextDeTarget) {
      if (this._lastTakenDeTarget !== nextDeTarget) {
        this._lastTakenDeTarget = nextDeTarget;
        this.updateCoordinator(nextDeTarget);
      }
    }
  }, {
    key: 'startAutoUpdateCoordinator',
    value: function startAutoUpdateCoordinator() {
      var _this2 = this;

      this.stopAutoUpdateCoordinator();

      if (!this.props.autoUpdateCoordinatorFrequency) {
        return;
      }

      this._autoUpdateCoordinatorSetT = setTimeout(function () {
        _this2.updateCoordinator(_this2.props.deTarget);
        _this2.startAutoUpdateCoordinator();
      }, this.props.autoUpdateCoordinatorFrequency);
    }
  }, {
    key: 'stopAutoUpdateCoordinator',
    value: function stopAutoUpdateCoordinator() {
      clearTimeout(this._autoUpdateCoordinatorSetT);
    }
  }, {
    key: 'updateCoordinator',
    value: function updateCoordinator(deTarget) {
      var _this3 = this;

      this.coordinator.setLocalRoot(deTarget.parentElement, deTarget, function (rect) {
        _this3.setState({ rect: rect });
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return !this.coordinator.isProcessing;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.coordinator.isProcessing) {
        return _react2['default'].createElement('div', { hidden: true });
      }

      var rect = this.state.rect;

      return rect ? _react2['default'].createElement(_Transhand2['default'], _extends({}, this.props, {
        rect: rect,
        coordinator: this.coordinator })) : _react2['default'].createElement('div', { hidden: true });
    }
  }]);

  return CSSTranshand;
})(_react2['default'].Component);

exports['default'] = CSSTranshand;
module.exports = exports['default'];
//# sourceMappingURL=CSSTranshand.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/CSSTranshand.js
 ** module id = 3286
 ** module chunks = 0
 **/